import React, { FC } from 'react';
import Link from 'next/link';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { Text } from '@shared/ui/atoms';
import { ICON_TCP } from '@shared/config';
import { homeSearchHitClickGtm } from '@shared/lib/gtm/redesign';
import { SearchPayee } from '../model/tsp.types';
import { getTspSearchItemHref } from '../lib/getTspSearchItemHref';
interface TspSuggestionItemProps {
  item: SearchPayee;
}
const TspSuggestionItem: FC<TspSuggestionItemProps> = ({
  item
}) => <Link href={getTspSearchItemHref(item)} onClick={() => homeSearchHitClickGtm(item.providerName)}>
    <TspSuggestionItemWrapper>
      <ImageWrapper>
        <Image src={`${ICON_TCP}${item.features?.tsp_picture_web}`} alt={item.providerName} />
      </ImageWrapper>
      <Text size="pS">{item.providerName}</Text>
    </TspSuggestionItemWrapper>
  </Link>;
export default TspSuggestionItem;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.hover;
const TspSuggestionItemWrapper = withTheme(/*#__PURE__*/styled('li')({
  name: "TspSuggestionItemWrapper",
  class: "thzgf40",
  propsAsIs: false,
  vars: {
    "thzgf40-0": [_exp()]
  }
}));
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "imvg6nv",
  propsAsIs: false
});
const Image = /*#__PURE__*/styled('img')({
  name: "Image",
  class: "i1rn7ecz",
  propsAsIs: false
});

require("./TspSuggestionItem.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./TspSuggestionItem.tsx");